export default "__VITE_ASSET__BLqHIFew__"